/**
 * API class to make requests to microsoft graph API
 */
import axios from 'axios'

export default class MSgraphApi {
  constructor() {
    this.graphURl = "https://graph.microsoft.com/v1.0"
  }
  
  /**
   * Get the profile image of the user
   * @param {string} token JWT access token of the logged in user
   */
  getImage(token) {
    const header = {
      Authorization: `Bearer ${token}`,
    }
    const config = {
      headers: header,
      responseType: 'blob'
    }
    return axios.get(`${this.graphURl}/me/photo/$value`, config).then(response => {
      return response.data
    })
  }

  /**
   * send an email. Email will be send from the logged in user.
   * The email will also be viisble in their sent items.
   * @param {*} emailObject object which contains to, subject and body fields for the email
   * @param {string} token JWT access token of logged in user
   */
  sendEmail(emailObject, token) {
    const header = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    }
    const config = {
      headers: header
    }
    return axios.post(`${this.graphURl}/me/sendMail` ,{
      message: {
        subject: emailObject.subject,
        body: {
          contentType: "Text",
          content: emailObject.body
        },
        toRecipients: emailObject.recipients
      },
      saveToSentItems: "true"
    }, config).then(response => {
      return response.data
    })
  }
  
  /**
   * Get Azure Active Directory profile of a user.
   * The returned promise includes the user's name, surname, microsoft id, etc
   * 
   * @param {strig} token JWT token of logged in user
   */
  getProfile(token) {
    const header = {
      Authorization: `Bearer ${token}`
    }
    const config = {
      headers: header,
      timeout: 10000
    }
    return axios.get(`${this.graphURl}/me`, config).then(response => {
      return response.data
    }, err => {
      throw new Error(response.text)
    })
  }

  /**
   * Get all the team information, i.e. profiles of everyone in the user's team
   * 
   * @param {string} token access token
   */
  getTeam(token) {
    const header = {
      Authorization: `Bearer ${token}`
    }
    const config = {
      headers: header
    }
    return axios.get(`${this.graphURl}/users`, config).then(response => {
      return response.data
    })
  }
}